module.exports = __webpack_public_path__ + "static/img/luoji_03.e0e3f2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/luoji_03.png
// module id = GxAF
// module chunks = 0